const Badge = {
   baseStyle: {
      borderRadius: 'md',
      display: 'inline-flex',
      fontSize: 'md',
      fontWeight: 'semibold',
      paddingInline: `6px`,
      placeItems: 'center',
      textTransform: 'normal',
   },
   defaultProps: {
      size: 'default',
   },
   sizes: {
      tiny: {
         fontSize: '10px',
         height: '20px',
      },
      default: {
         height: '28px',
      },
   },
};

export default Badge;
